export default __webpack_public_path__ + "static/media/Widerrufsrecht.13d58528.md";